// extracted by mini-css-extract-plugin
export var columnList = "_ev-0";